import { ProfileModal as ProfileModalUi } from '@slims-pro/ui/organisms';
import { useMe } from '@/hooks/use-me';
import { useMeta } from '@/hooks/use-meta';
import { api } from '@/lib/api';
import { roleLabel } from '@/lib/format';
import { useUIStore } from '@/stores/ui-store';

/**
 * Profilo in sola lettura: con OIDC nome e avatar li gestisce l'IdP, quindi nessun callback
 * di modifica. "Esci" chiude la sessione OIDC; in dev mode non c'è sessione da chiudere.
 */
export function ProfileModal() {
	const activeModal = useUIStore((s) => s.activeModal);
	const closeModal = useUIStore((s) => s.closeModal);
	const me = useMe().data;
	const meta = useMeta().data;
	if (!me) return null;

	// Dev mode has no session to end.
	const signOut =
		meta?.auth.mode === 'oidc'
			? async () => {
					const { data } = await api.POST('/api/v1/auth/logout');
					window.location.assign(data?.logoutUrl ?? '/');
				}
			: undefined;

	return (
		<ProfileModalUi
			open={activeModal === 'profile'}
			onClose={closeModal}
			onSignOut={signOut}
			user={{
				fullName: me.fullName ?? null,
				email: me.email ?? null,
				avatarUrl: null,
				roleLabel: roleLabel(me.roles),
				organizationName: me.organizationName,
				createdAt: null,
			}}
		/>
	);
}
